"use strict";
// @ts-ignore
try {
    self['workbox:cacheable-response:6.5.3'] && _();
}
catch (e) { }
